import { type ReactNode } from 'react'
import styles from './EmptyState.module.css'

interface Props {
  icona?: ReactNode
  titolo: string
  descrizione?: string
  azione?: ReactNode
}

export function EmptyState({ icona, titolo, descrizione, azione }: Props) {
  return (
    <div className={styles.wrap}>
      {icona && <div className={styles.icona}>{icona}</div>}
      <h3 className={styles.titolo}>{titolo}</h3>
      {descrizione && <p className={styles.descrizione}>{descrizione}</p>}
      {azione && <div className={styles.azione}>{azione}</div>}
    </div>
  )
}
